import { Circuit, CircuitResume, CircuitResumeExternal, CircuitType } from '@core/interfaces/circuits.interface'
import { EntriesResponse, ExternalFormsField } from 'superlikers-microsites-api'
import { transformStringToNumber } from './kpis.adapter'

/**
 * Adapta los datos externos de un circuito al modelo interno Circuit
 *
 * @param {string} id - Identificador único del circuito
 * @param {ExternalFormsField[]} fields - Campos del formulario del externalForm a transformar
 * @param {string} category - Categoría del circuito
 * @returns {Circuit} Objeto Circuit con los datos transformados
 */
export const circuitAdapter = (id: string, fields: ExternalFormsField[], category: string) => {
  const data = getTransformedFields(fields)

  const circuit = { id, category, ...data } as Circuit
  if (!circuit.type) circuit.type = CircuitType.NORMAL

  return circuit
}

export const circuitResumeAdapter = (externals: EntriesResponse<CircuitResumeExternal>) => {
  const data = externals.data.at(0)?.data

  if (!data) return null

  return {
    points: transformStringToNumber(data.points),
    points_name: data.points_name,
    percentage: transformStringToNumber(data.percentage)
  } as CircuitResume
}

/**
 * Transforma los campos del formulario del ExternalForm a un formato utilizable
 * internamente en la aplicación
 *
 * @param {ExternalFormsField[]} fields - Campos del formulario del externalForm a transformar
 * @returns {Record<string, unknown>} Objeto con los campos transformados
 */
const getTransformedFields = (fields: ExternalFormsField[]) => {
  const transformedData: Record<string, unknown> = {}

  fields.forEach(field => {
    const { name, default_value, type_value, choices } = field

    if (type_value === 'Array') {
      transformedData[name] = choices
    } else if (type_value === 'Time') {
      transformedData[name] = new Date(default_value)
    } else {
      transformedData[name] = default_value
    }
  })

  return transformedData
}
